module.exports = __webpack_public_path__ + "static/media/female-blue.34bb08f8.png";